import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './CookieBanner.module.css';

export default function CookieBanner() {
  const [visible,  setVisible]  = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const consent = localStorage.getItem('simplifyqr_cookie');
      if (!consent) setVisible(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const accept = () => {
    localStorage.setItem('simplifyqr_cookie', 'accepted');
    localStorage.setItem('simplifyqr_cookie_date', new Date().toISOString());
    setVisible(false);
    // Load Google Analytics now that consent is given
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
      });
    }
  };

  const decline = () => {
    localStorage.setItem('simplifyqr_cookie', 'declined');
    localStorage.setItem('simplifyqr_cookie_date', new Date().toISOString());
    setVisible(false);
    // Block analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
      });
    }
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="dialog" aria-label="Cookie consent">

      <div className={styles.top}>
        <div className={styles.icon}>🍪</div>
        <div className={styles.content}>
          <p className={styles.title}>We use cookies</p>
          <p className={styles.text}>
            We use Google Analytics and AdSense cookies to improve your experience and keep SimplifyQR free.
            Core QR tools work without cookies.{' '}
            <button
              className={styles.learnMore}
              onClick={() => setExpanded(v => !v)}
            >
              {expanded ? 'Show less ↑' : 'Learn more ↓'}
            </button>
          </p>

          {expanded && (
            <div className={styles.details}>
              <div className={styles.detailItem}>
                <span className={styles.detailIcon}>📊</span>
                <div>
                  <strong>Analytics (Google Analytics)</strong>
                  <p>Anonymous usage data — pages visited, device type. No personal info.</p>
                </div>
              </div>
              <div className={styles.detailItem}>
                <span className={styles.detailIcon}>📢</span>
                <div>
                  <strong>Advertising (Google AdSense)</strong>
                  <p>Shows relevant ads. Revenue keeps SimplifyQR free forever.</p>
                </div>
              </div>
              <div className={styles.detailItem}>
                <span className={styles.detailIcon}>💾</span>
                <div>
                  <strong>Preferences (localStorage)</strong>
                  <p>Theme, QR history — stored on your device only. Always active.</p>
                </div>
              </div>
              <p className={styles.policyLinks}>
                Read our{' '}
                <Link to="/privacy-policy" onClick={decline}>Privacy Policy</Link>
                {' '}and{' '}
                <Link to="/cookie-policy" onClick={decline}>Cookie Policy</Link>
              </p>
            </div>
          )}
        </div>
      </div>

      <div className={styles.btns}>
        <button className={styles.btnDecline} onClick={decline}>
          Decline
        </button>
        <button className={styles.btnAccept} onClick={accept}>
          Accept All
        </button>
      </div>

    </div>
  );
}